<template>
  <div>
    <el-row>
      <div style="height:70px;"></div>
    </el-row>
    <el-row justify="center" align="middle">
      <el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2">&nbsp;</el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:center;">
        <img src="../assets/cvlogo3.jpg" style="width:284px;">
        <!--style="position: absolute;top: 0;left: 0;height: 284px;border:1px solid #D5D5D5;border-radius:5px">
        --->
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="10" :xl="10">
        <el-form ref="form" :model="form">
          <el-form-item label="联系人">
            <el-input
              v-model="$root.basicInfo.nick"
              v-on:input="$emit('basic-infomation-data',form)"
              placeholder="请填写联系人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="QQ">
            <el-input
              v-model="$root.basicInfo.qq"
              v-on:input="$emit('basic-infomation-data',form)"
              placeholder="请填写您的QQ"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="$root.basicInfo.phone"
              v-on:input="$emit('basic-infomation-data',form)"
              placeholder="请留下您的手机号（必填）"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :xs="0" :sm="2" :md="0" :lg="2" :xl="2">&nbsp;</el-col>
    </el-row>
    <el-row>
      <div style="height:70px;"></div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      forcollapse: ["allsame"],
      // form: this.props.basicInfo

      form: {
        name: "",
        qq: "",
        phone: ""
      }
    };
  },
  name: "BasicInfo",
  /*props: {
    msg: String,
  }*/
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
